import {FC} from "react";
import {Button, Dialog, DialogActions, DialogContent, styled, Typography, Box} from "@mui/material";

interface IProps {
	onClose: () => void;
	onAccept: () => void;
}

export const ConfirmClearEnrollmentsDialog: FC<IProps> = ({onClose, onAccept}) => {
	return (
		<Dialog open={true} onClose={onClose}>
			<DialogContent
				sx={theme => ({
					backgroundColor: theme.palette.background.paperElevation4
				})}
			>
				<Typography variant="h6">Clear Existing Auto-Enrollments?</Typography>
				<Box padding={1}></Box>
				<Typography sx={{opacity: 0.7}}>
          This will remove all current auto-enrollments for every user.
				</Typography>
				<Typography sx={{opacity: 0.7}}>
          Progress will be kept for any courses already started, but enrollments will be removed.
				</Typography>
				<Box padding={1}></Box>
				<Typography sx={{opacity: 0.7, fontWeight: 700}}>
          This action cannot be undone.
				</Typography>
			</DialogContent>
			<DialogActions
				sx={theme => ({
					paddingTop: 0,
					backgroundColor: theme.palette.background.paperElevation4
				})}
			>
				<ButtonStyled variant="text" aria-label="Cancel action" onClick={onClose}>
          Cancel
				</ButtonStyled>
				<ButtonStyled variant="text" aria-label="Confirm action" onClick={onAccept}>
          Clear
				</ButtonStyled>
			</DialogActions>
		</Dialog>
	);
};

const ButtonStyled = styled(Button)(({theme}) => ({
	border: "none",
	color: theme.palette.primary.main,
	"&:hover": {
		backgroundColor: "transparent"
	}
}));

